import { render, staticRenderFns } from "./NewWorklog.vue?vue&type=template&id=28054d32&"
import script from "./NewWorklog.vue?vue&type=script&lang=ts&"
export * from "./NewWorklog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports